/**
 * Error thrown when the access token refresh request fails.
 * Consuming applications can catch this error to identify expired or invalid sessions.
 */
export class AuthRefreshError extends Error {
  /**
   * The original error returned by the token refresh call (typically an AxiosError).
   */
  public readonly originalError?: any;

  constructor(message: string, originalError?: any) {
    super(message);
    this.name = 'AuthRefreshError';
    this.originalError = originalError;

    // Restore prototype chain for proper inheritance check in ES5/ES6 environments
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
